/** The TV monitor's routes: /monitor, and /monitor_v2 showing the same globe. */
export const MONITOR_PATHS: readonly string[] = ['/monitor', '/monitor_v2'];

export const isMonitorPath = (pathname: string): boolean =>
  MONITOR_PATHS.includes(pathname);
